module.exports = __webpack_public_path__ + "img/query.1aa1f74c.png";